import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldWork']),
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldWork'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldWork'])
    },
}